import Api from '@/services/Api'

// Teya POSLink. Sve tajne ostaju na posluzitelju - ovdje se sale samo firma,
// iznos i oznaka racuna, a natrag dolazi stanje naplate.
export default {
  // stanje veze ove firme s Teyom
  veza (query) {
    return Api().get('teya/veza', {params: query})
  },
  odspoji (query) {
    return Api().delete('teya/veza', {params: query})
  },
  // adresa na koju se trgovca salje da se prijavi
  prijava (query) {
    return Api().get('teya/prijava', {params: query})
  },
  // kod s povratne adrese; ide bez tokena jer je sjednica nakon povratka
  // izgubljena (prijava je prosla kroz cijelo ucitavanje stranice)
  povratak (data) {
    return Api().post('teya/povratak', data)
  },
  poslovnice (query) {
    return Api().get('teya/poslovnice', {params: query})
  },
  aparati (query) {
    return Api().get('teya/aparati', {params: query})
  },
  odaberi (data) {
    return Api().post('teya/odaberi', data)
  },

  // naplata
  naplati (data) {
    return Api().post('teya/naplati', data)
  },
  placanje (query) {
    return Api().get('teya/placanje', {params: query})
  },
  prekini (data) {
    return Api().post('teya/prekini', data)
  },
  slip (query) {
    return Api().get('teya/slip', {params: query})
  },

  // stari naziv, zove ga POSfast
  initiate (data) {
    return Api().post('teya/initiate', data)
  }
}
